

















































































































































































































/* tslint:disable:only-arrow-functions*/

import Vue from 'vue';
import Component from 'vue-class-component';
import getFileSizeHumanReadable from '@/util/file-size';
import AnimatedInput from '@/components/AnimatedInput.vue';
import Browsercheck from '@/components/Browsercheck.vue';
import wait from "@/util/wait";
import {Action, Getter, Mutation} from "vuex-class";
import KeyUtility from "../util/keyUtility";
import Base64Encoder from "../util/base64encoder";
// @ts-ignore Somehow installing @types/vue2-datepicker breaks all typescript
import DatePicker from 'vue2-datepicker';
import messageBus from "@/util/messageBus";
import PricingCalculator from "@/util/pricingCalculator";
import featureFlags from "@/util/featureFlags";
import dayjs from "@/util/dayjs";

@Component({
    components: { AnimatedInput, Browsercheck, DatePicker },
})
export default class Upload extends Vue {
    // Tell the IDE that the mapped getters and setters exist...
    @Mutation setFileDragActive!: () => void;
    @Mutation setFileDragInactive!: () => void;
    @Mutation startOverWithUpload!: () => void;
    @Mutation setFile!: (file: File) => void;
    @Mutation setUploadPassword!: (password: string) => void;
    @Mutation setUploadUsesPassword!: (state: boolean) => void;
    @Mutation setUploadFile!: (file: File) => void;
    @Mutation addUploadFile!: (file: File) => void;
    @Mutation removeUploadFile!: (file: File) => void;
    @Mutation setMetaKey!: (metaKey: CryptoKey) => void;
    @Mutation setPasswordSalt!: (passwordSalt: Uint8Array) => void;
    @Mutation setUploadExpiration!: (date: Date) => void;

    @Getter isLoggedIn!: boolean;
    @Getter showUploadForm!: boolean;
    @Getter showUploadProgress!: boolean;
    @Getter showUploadSuccess!: boolean;
    @Getter showUploadError!: boolean;
    @Getter hasUploadFile!: boolean;

    @Action uploadMetadata!: (letterboxAddress: string | null) => Promise<any>;
    @Action uploadChunks!: () => Promise<any>;
    @Action commitUpload!: (neededForDecryption: string) => Promise<any>;

    eventcount: number = 0;
    animateProgress: boolean = true;
    agreesToS: boolean = false;

    get usesPassword() {
        return this.$store.state.upload.usesPassword;
    }

    set usesPassword(password) {
        this.setUploadUsesPassword(password);
    }

    get password() {
        return this.$store.state.upload.password;
    }

    set password(password) {
        this.setUploadPassword(password);
    }

    get uploadError() {
        return this.$store.state.upload.error;
    }

    get progress() {
        return this.$store.state.upload.overallProgress;
    }

    get currentUploadingFile() {
      return this.$store.state.upload.currentlyUploadingFile;
    }

    get fileLink() {
        return this.$store.state.upload.linkForPartner;
    }

    dragAndDropActive() {
        return this.$store.state.showFileDragActive;
    }

    get files(): File[] {
      return this.$store.state.upload.files as File[];
    }

    get expirationDate(): Date {
      return this.$store.state.upload.uploadExpiration;
    }

    set expirationDate(date: Date) {
      this.setUploadExpiration(date);
    }

    sizeHumanReadable(file: File): string {
      return getFileSizeHumanReadable(file.size);
    }

    chooseFile() {
        const ref: any = this.$refs.uploadFiles as HTMLInputElement;
        const files = ref.files;

        for (const file of files) {
          this.checkForDuplicatesAndAddFile(file);
        }
    }

  disabledBeforeToday(date: Date) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const upperLimit = dayjs().add(1000, "days").toDate(); //Only allow up to 1000 days in the future!
    return date < today || date > upperLimit;
  }

    copyLinkToClipboard() {

        const copyText: HTMLInputElement = document.createElement("input");
        document.body.appendChild(copyText);
        copyText.value = this.fileLink;
        copyText.select();
        document.execCommand("copy");
        document.body.removeChild(copyText);
        this.$swal('Erfolg', 'Du kannst den Link jetzt in einem verschlüsselten Messenger verschicken.', 'success');
    }

    checkForDuplicatesAndAddFile(file: File) {
        const idx: number = (this.$store.state.upload.files as File[]).findIndex((f: File) => {
            return f.name === file.name;
        });

        if (idx > -1) {
          this.$swal('Gleiche Dateinamen', 'Du kannst keine zwei Dateien versenden, die den gleichen Namen tragen.', 'error');
        } else {
          this.addUploadFile(file);
        }
    }

    get isProNeeded(): boolean {
      return !this.isLoggedIn && (
        !PricingCalculator.uploadIsInFreeTier(this.$store.state.upload.files, this.expirationDate)
        || this.$store.state.upload.allowComments
        || this.$store.state.upload.enableApproval
        || this.$store.state.upload.requireName );
    }

    get freeSizeLimit() {
      return getFileSizeHumanReadable(featureFlags.freeTierTransferLimit);
    }

    get freeFileLimit() {
      return featureFlags.freeTierFileLimit;
    }

    get estimatedTokenCostForUpload(): number {
      return PricingCalculator.getEstimatedTokenCostOfUpload(this.$store.state.upload.files, this.expirationDate);
    }

    get proNeededString(): string {
      return `Wenn Sie mehr als ${this.freeFileLimit} Datei / ${this.freeSizeLimit} übertragen oder zusätzliche Features wie z.B. Kommentare oder die Gültigkeit ändern möchten, ist eine Pro-Mitgliedschaft notwendig.`;
    }

    async uploadFile() {

      //Check if upload is in free Tier:
        if (this.isProNeeded) {
          messageBus.$emit('auth-interactive-needed', this.proNeededString);
          return;
        }

        let metaKey: CryptoKey;
        let neededForDecryption: string;
        if (this.usesPassword) {
            const salt = KeyUtility.generatePBKDFSalt();
            metaKey = await KeyUtility.deriveKeyFromPassword(this.password, salt);
            neededForDecryption = Base64Encoder.bytesToString(salt);
            this.setPasswordSalt(salt);
        } else {
            metaKey = await KeyUtility.generateRandomKey();
            neededForDecryption = await KeyUtility.exportKeyToBase64(metaKey);
        }
        this.setMetaKey(metaKey);
        await this.uploadMetadata(null);
        this.$log.debug("Metadata uploaded, next: Chunks");
        await this.uploadChunks();
        await wait(550); //Wait for the animation to complete
        this.$log.debug("Chunks uploaded, next: Commit");
        await this.commitUpload(neededForDecryption);
        this.$log.debug("Upload done");
        return;
    }

  //Drag & Drop setup:
  dragEnterHandler(e: DragEvent) {
    e.preventDefault();
    this.eventcount++;
    this.setFileDragActive();
    return false;
  }

  dragLeaveHandler(e: DragEvent) {
    e.preventDefault();
    // Check if Dragleave is really a leave or just a leave for one container:
    this.eventcount--;
    if (this.eventcount === 0) {
      this.setFileDragInactive();
    }
    return false;
  }

  dragOverHandler(e: DragEvent) {
    e.preventDefault();
  }

  dropHandler(e: DragEvent) {
    e.preventDefault();
    e.stopPropagation();
    //Clear state of upload form:
    this.eventcount = 0;
    this.setFileDragInactive();
    if (!e.dataTransfer) {
      return false;
    }
    if (e.dataTransfer.files) {
      for (const file of e.dataTransfer.files) {
        this.checkForDuplicatesAndAddFile(file);
      }
    } else { //Weird, it should contain files, but lets search manually!
      for (const item of e.dataTransfer.items) {
        if (item.kind === "file") {
          const f: File | null = item.getAsFile();
          if (f) {
            this.checkForDuplicatesAndAddFile(f);
          }
        }
      }
    }
    return false;
  }

    mounted() {
      this.$nextTick(() => {
        this.agreesToS = this.isLoggedIn;
      });

      window.addEventListener('dragenter', this.dragEnterHandler, false);
      window.addEventListener('dragleave', this.dragLeaveHandler, false);
      window.addEventListener('dragover', this.dragOverHandler, false);
      window.addEventListener('drop', this.dropHandler, false);
    }

  beforeDestroy() {
    window.removeEventListener('dragenter', this.dragEnterHandler, false);
    window.removeEventListener('dragleave', this.dragLeaveHandler, false);
    window.removeEventListener('dragover', this.dragOverHandler, false);
    window.removeEventListener('drop', this.dropHandler, false);
  }

    goToProSite() {
      this.$router.push('/pro');
    }
}
